import { render } from "./Returns.vue?vue&type=template&id=17bf39fa&scoped=true"
import script from "./Returns.vue?vue&type=script&lang=js"
export * from "./Returns.vue?vue&type=script&lang=js"

import "./Returns.vue?vue&type=style&index=0&id=17bf39fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bf39fa"]])

export default __exports__